import { post } from '../utils/backend';
import { SalesOverview } from '../models/Dashboard';
import { mock, getMockData } from './mock/DashboardMock';

interface GetOverviewParams {
    monthTime: Date;
}

interface GetHistoryParams {
    months: number; // 获取最近几个月的数据
}

const getOverview = async (params: GetOverviewParams): Promise<SalesOverview> => {
    if (mock) {
        return getMockData('GET_OVERVIEW');
    }
    const resultOrErrorCode = await post<GetOverviewParams, SalesOverview>('/management/dashboard/getOverview', params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return {} as SalesOverview;
    }
    return resultOrErrorCode;
};

const getOverviewHistory = async (params: GetHistoryParams): Promise<SalesOverview[]> => {
    if (mock) {
        return getMockData('GET_OVERVIEW_HISTORY');
    }
    const resultOrErrorCode = await post<GetHistoryParams, SalesOverview[]>('/management/dashboard/getOverviewHistory', params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

export const DashboardApi = {
    getOverview,
    getOverviewHistory
}; 